import { Component } from '@angular/core';

@Component({
  selector: 'app-info-v-valida-departamental',
  imports: [],
  templateUrl: './info-v-valida-departamental.html',
  styleUrl: './info-v-valida-departamental.scss'
})
export class InfoVValidaDepartamental {

}
